import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "core-js";

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import "./index.css";

import * as serviceWorker from "./serviceWorker";

import { BrowserRouter } from "react-router-dom";

import Reducer from "./_reducers";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import promiseMiddleware from "redux-promise";
import ReduxThunk from "redux-thunk";

import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import authStore, { types as authTypes } from "./_stores/auth.store";


const createStoreWithMiddleware = applyMiddleware(promiseMiddleware, ReduxThunk)(createStore);

// MSAL configuration
const configuration = {
  auth: {
    authority: "https://login.microsoftonline.com/5989ece0-f90e-40bf-9c79-1a7beccdb861",
    clientId: "2f35ff1b-d6b5-4439-b778-f4fd2c5aab86",
    redirectUri: "https://dst.iqvia.com/auth",
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

const pubClientApp = new PublicClientApplication(configuration);

pubClientApp.addEventCallback(async (event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    pubClientApp.setActiveAccount(event.payload.account);
    console.log("Login Success event.payload => ", event.payload);
    authStore.dispatch({ type: authTypes.SET_SSO_STATE, payload: event.payload });
  }
});

const SUB_DOMAIN = process.env.REACT_APP_SUB_DOMAIN;

// React 18 API
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider
    store={createStoreWithMiddleware(Reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())}
  >
    <MsalProvider instance={pubClientApp}>
      <BrowserRouter basename={SUB_DOMAIN}>
        <App />
      </BrowserRouter>
    </MsalProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
